import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=2b43b6e5"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=2b43b6e5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b43b6e5')) {
      api.createRecord('2b43b6e5', component.options)
    } else {
      api.reload('2b43b6e5', component.options)
    }
    module.hot.accept("./Forgot.vue?vue&type=template&id=2b43b6e5", function () {
      api.rerender('2b43b6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Forgot.vue"
export default component.exports